import clsx from 'clsx'

type HeadingProps = { level?: 1 | 2 | 3 | 4 | 5 | 6 } & React.ComponentPropsWithoutRef<
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>

const getHeadingSize = (level: number) => {
  switch (level) {
    case 1:
      return 'text-4xl/10 sm:text-3xl/9'
    case 2:
      return 'text-3xl/9 sm:text-2xl/8'
    case 3:
      return 'text-2xl/8 sm:text-xl/7'
    case 4:
      return 'text-xl/7 sm:text-lg/7'
    case 5:
      return 'text-lg/7 sm:text-base/6'
    case 6:
      return 'text-base/6 sm:text-sm/6'
    default:
      return 'text-2xl/8 sm:text-xl/8'
  }
}

export const Heading = ({ className, level = 1, ...props }: HeadingProps) => {
  const Element: `h${typeof level}` = `h${level}`
  return (
    <Element
      {...props}
      className={clsx(className, getHeadingSize(level), 'font-semibold text-gray-900 dark:text-white')}
    />
  )
}

export const Subheading = ({ className, level = 2, ...props }: HeadingProps) => {
  const Element: `h${typeof level}` = `h${level}`
  return (
    <Element
      {...props}
      className={clsx(className, 'text-base/7 font-semibold text-gray-900 sm:text-sm/6 dark:text-white')}
    />
  )
}
